import React from "react";
import "./styles/style.scss";
import { persistor, store } from "./config/store";
import { Provider } from "react-redux";
import { createBrowserHistory, History } from "history";
import { ToastContextProvider } from "./providers/Toast";
import { ModalContextProvider } from "./providers/Modal";
import "react-toastify/dist/ReactToastify.css";
import { GlobalLoadingContextProvider } from "./providers/GlobalLoading";
import { PersistGate } from "redux-persist/integration/react";
import Main from "./Main";
import { Router, useLocation } from "react-router-dom";

function App() {
  let history: History = createBrowserHistory();

  return (
    <div className="meeters-app">
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <GlobalLoadingContextProvider>
            <ToastContextProvider>
              <ModalContextProvider>
                <Router history={history}>
                  <Main history={history}/>
                </Router>
              </ModalContextProvider>
            </ToastContextProvider>
          </GlobalLoadingContextProvider>
        </PersistGate>
      </Provider>
    </div>
  );
}

export default App;
